import axios from "axios";

export function storeSubdomain(subDomain) {
  let key = `sub_domain_${subDomain.sub_domain}`;
  localStorage.removeItem(key);
  localStorage.setItem(key, JSON.stringify(subDomain));
}

async function getSubdomain() {
  let full = window.location.hostname;
  let sub = full.split(".")[0];
  sub = sub.toLowerCase();
  return axios
    .get(`${process.env.VUE_APP_API_URL}sub-domains/${sub}/`)
    .then(response => {
      let subDomain = response.data;
      return subDomain;
    })
    .catch(() => {
      return {
        logo: "/img/white_logo.png",
        header_color: "#3f51b5",
        logo_height: "24"
      };
    });
}

export default getSubdomain;
